import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/index';

// Containers
import Full from '@/containers/Full';

// Views
import Dashboard from '@/views/Dashboard';

// Pages
import Login from '@/pages/Login';
import Vergeten from '@/pages/Vergeten';
import Page404 from '@/pages/Page404';

import NewBedrijf from '@/pages/bedrijf/New';
import IndexBedrijven from '@/pages/bedrijf/Index';
import EditBedrijf from '@/pages/bedrijf/Edit';

import NewAccount from '@/pages/account/New';
import IndexAccounts from '@/pages/account/Index';
import EditAccount from '@/pages/account/Edit';
import ActivateAccount from '@/pages/account/Activate';
import EditMijnAccount from '@/pages/account/EditMijnAccount';

import NewAfdeling from '@/pages/afdeling/New';
import IndexAfdelingen from '@/pages/afdeling/Index';
import EditAfdeling from '@/pages/afdeling/Edit';

import NewAfdelingTeelt from '@/pages/afdelingteelt/New';
import IndexAfdelingenTeelt from '@/pages/afdelingteelt/Index';
import EditAfdelingTeelt from '@/pages/afdelingteelt/Edit';

import NewGlastype from '@/pages/glastype/New';
import IndexGlastypes from '@/pages/glastype/Index';
import EditGlastype from '@/pages/glastype/Edit';

import NewSoortbelichting from '@/pages/soortbelichting/New';
import IndexSoortbelichting from '@/pages/soortbelichting/Index';
import EditSoortbelichting from '@/pages/soortbelichting/Edit';

import NewTeelt from '@/pages/teelt/New';
import IndexTeelt from '@/pages/teelt/Index';
import EditTeelt from '@/pages/teelt/Edit';

import EditDliprofiel from '@/pages/licht/EditDliprofiel';
import EditKlassiek from '@/pages/licht/EditKlassiek';
import ShowLicht from '@/pages/licht/ShowIntegratie';
import ShowSamenvatting from '@/pages/licht/ShowSamenvatting';
import EditWerkelijk from '@/pages/licht/EditWerkelijk';

import WeerVoorspelling from '@/pages/weer/Voorspelling';
import WeerStation from '@/pages/weerstation/Homepage';

Vue.use(Router);

const router = new Router({
    mode: 'hash',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/',
            redirect: '/home',
            name: 'Home',
            component: Full,
            children: [
                {
                    path: 'home',
                    name: 'Info',
                    component: Dashboard,
                },
                {
                    path: 'mijnaccount',
                    name: 'Mijn account',
                    component: EditMijnAccount,
                },
                {
                    path: 'beheer',
                    name: 'Beheer',
                    redirect: '/beheer/bedrijf',
                    component: {
                        render (c) { return c('router-view'); },
                    },
                    children: [
                        {
                            path: 'bedrijf',
                            name: 'Bedrijven',
                            redirect: '/beheer/bedrijf',
                            component: {
                                render (c) { return c('router-view'); },
                            },
                            children: [
                                {
                                    path: 'new',
                                    name: 'Nieuw-1',
                                    component: NewBedrijf,
                                },
                                {
                                    path: '',
                                    name: 'Index-1',
                                    component: IndexBedrijven,
                                },
                                {
                                    path: 'edit/:id',
                                    name: 'Wijzig-1',
                                    component: EditBedrijf,
                                },
                            ],
                        },
                        {
                            path: 'account',
                            name: 'Accounts',
                            redirect: '/beheer/account',
                            component: {
                                render (c) { return c('router-view'); },
                            },
                            children: [
                                {
                                    path: 'new',
                                    name: 'Nieuw-2',
                                    alias: 'NewAccount',
                                    component: NewAccount,
                                },
                                {
                                    path: '',
                                    name: 'Index-2',
                                    component: IndexAccounts,
                                },
                                {
                                    path: 'edit/:id',
                                    name: 'Wijzig-2',
                                    component: EditAccount,
                                },
                                {
                                    path: 'activate/:id',
                                    name: 'Activeer-2',
                                    component: ActivateAccount,
                                },
                            ],
                        },
                        {
                            path: 'afdeling',
                            name: 'Afdelingen',
                            redirect: '/beheer/afdeling',
                            component: {
                                render (c) { return c('router-view'); },
                            },
                            children: [
                                {
                                    path: 'new',
                                    name: 'Nieuw-3',
                                    component: NewAfdeling,
                                },
                                {
                                    path: '',
                                    name: 'Index-3',
                                    component: IndexAfdelingen,
                                },
                                {
                                    path: 'edit/:id',
                                    name: 'Wijzig-3',
                                    component: EditAfdeling,
                                },
                            ],
                        },
                        {
                            path: 'afdelingteelt',
                            name: 'Teelten',
                            redirect: '/beheer/afdelingteelt',
                            component: {
                                render (c) { return c('router-view'); },
                            },
                            children: [
                                {
                                    path: 'new',
                                    name: 'Nieuw-6',
                                    component: NewAfdelingTeelt,
                                },
                                {
                                    path: '',
                                    name: 'Index-6',
                                    component: IndexAfdelingenTeelt,
                                },
                                {
                                    path: 'edit/:id',
                                    name: 'Wijzig-6',
                                    component: EditAfdelingTeelt,
                                },
                                {
                                    path: 'dliprofiel/:id',
                                    name: 'DLI profiel',
                                    component: EditDliprofiel,
                                },
                                {
                                    path: 'klassiek/:id',
                                    name: 'Klassiek belichtingsschema',
                                    component: EditKlassiek,
                                },
                                {
                                    path: 'lichtintegratie/:id',
                                    name: 'Lichtintegratie',
                                    component: ShowLicht,
                                },
                                {
                                    path: 'samenvatting/:id',
                                    name: 'Lichtintegratie vs. klassiek belichtingsschema',
                                    component: ShowSamenvatting,
                                },
                                {
                                    path: 'werkelijk/:id',
                                    name: 'Werkelijke belichting',
                                    component: EditWerkelijk,
                                },
                            ],
                        },
                        {
                            path: 'glastype',
                            name: 'Glastypes',
                            redirect: '/beheer/glastype',
                            component: {
                                render (c) { return c('router-view'); },
                            },
                            children: [
                                {
                                    path: 'new',
                                    name: 'Nieuw-4',
                                    component: NewGlastype,
                                },
                                {
                                    path: '',
                                    name: 'Index-4',
                                    component: IndexGlastypes,
                                },
                                {
                                    path: 'edit/:id',
                                    name: 'Wijzig-4',
                                    component: EditGlastype,
                                },
                            ],
                        },
                        {
                            path: 'soortbelichting',
                            name: 'Soorten belichting',
                            redirect: '/beheer/soortbelichting',
                            component: {
                                render (c) { return c('router-view'); },
                            },
                            children: [
                                {
                                    path: 'new',
                                    name: 'Nieuw-5',
                                    component: NewSoortbelichting,
                                },
                                {
                                    path: '',
                                    name: 'Index-5',
                                    component: IndexSoortbelichting,
                                },
                                {
                                    path: 'edit/:id',
                                    name: 'Wijzig-5',
                                    component: EditSoortbelichting,
                                },
                            ],
                        },
                        {
                            path: 'teelt',
                            name: 'Teeltsoorten',
                            redirect: '/beheer/teelt',
                            component: {
                                render (c) { return c('router-view'); },
                            },
                            children: [
                                {
                                    path: 'new',
                                    name: 'Nieuw-7',
                                    component: NewTeelt,
                                },
                                {
                                    path: '',
                                    name: 'Index-7',
                                    component: IndexTeelt,
                                },
                                {
                                    path: 'edit/:id',
                                    name: 'Wijzig-7',
                                    component: EditTeelt,
                                },
                            ],
                        },
                    ],
                },
                {
                    path: 'weer',
                    name: 'Weer',
                    redirect: '/weer/voorspelling',
                    component: {
                        render (c) { return c('router-view'); },
                    },
                    children: [
                        {
                            path: 'voorspelling',
                            name: 'Voorspelling',
                            component: WeerVoorspelling,
                        },
                        {
                            path: 'weerstation',
                            name: 'Weerstation',
                            component: WeerStation,
                        },
                    ],
                },
            ],
        },
        {
            path: '/pages',
            redirect: '/pages/404',
            name: 'Pages',
            component: {
                render (c) { return c('router-view'); },
            },
            children: [
                {
                    path: '404',
                    name: 'Page404',
                    component: Page404,
                },
                {
                    path: 'login',
                    name: 'Login',
                    component: Login,
                },
                ,
                {
                    path: 'vergeten',
                    name: 'Wachtwoord vergeten',
                    component: Vergeten,
                },
            ],
        },
        {
            path: '*',
            redirect: '/pages/404',
        },
    ],
});

router.beforeEach((to, from, next) => {
    /* eslint-disable no-console */
    /* console.log(store.getters.expire);
    console.log(new Date().getTime()); */
    if ((to.path !== '/pages/login') && (to.path !== '/pages/vergeten') && (!store.getters.isLoggedIn || store.getters.expire < (new Date().getTime()))) {
        store.dispatch('logout');
        next({ path: '/pages/login' });
    } else {
        next();
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js